// src/pages/Login.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { loginUser } from "../utils/auth";
import "../styles/styles.css";

const Login = ({ setUser }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    // loginUser ahora devuelve { success, user } en lugar de solo success
    const result = loginUser(email.trim(), password);
    if (!result.success) {
      setError(result.message);
      return;
    }

    // Guardamos en estado global el objeto user { email, role }
    setUser(result.user);

    // Redirigimos según el rol
    const { role } = result.user;
    if (role === "admin") {
      navigate("/admin/submissions");
    } else if (role === "creator") {
      navigate("/upload");
    } else {
      navigate("/");
    }
  };

  return (
    <div className="auth-container">
      <h2
        style={{
          color: "var(--color-text)",
          fontFamily: "var(--font-family-heading)",
        }}
      >
        Iniciar Sesión
      </h2>
      <form onSubmit={handleSubmit} className="auth-form">
        {error && <p className="error-message">{error}</p>}
        <label htmlFor="email">Correo Electrónico:</label>
        <input
          type="email"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <label htmlFor="password">Contraseña:</label>
        <input
          type="password"
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <button type="submit" className="btn-submit">
          Iniciar Sesión
        </button>
        <p style={{ marginTop: "1rem", color: "var(--color-text-secondary)" }}>
          ¿No tienes cuenta? <Link to="/register">Regístrate aquí</Link>
        </p>
      </form>
    </div>
  );
};

export default Login;
